import { useState, useRef, useEffect } from "react";
import { useRaspStore } from "../store/raspStore";
import { applicantService } from "../services/ApplicantService";
import Cookies from "js-cookie";

// getUserIdFromJWT removed - using LoginContext

export const useApplicantViewModel = (userId: string, appId: string) => {
  const [fields, setFields] = useState<any[]>([]);
  const [foreignKeyData, setForeignKeyData] = useState<any>({});
  const [enums, setEnums] = useState<any>({});
  // const [dataToSave, setDataToSave] = useState<any>({});
  const [fetchedForeign, setFetchedForeign] = useState<Set<string>>(new Set());
  const [fetchedEnum, setFetchedEnum] = useState<Set<string>>(new Set());
  const addSubmission = useRaspStore((s) => s.addSubmission);
  const getSubmissions = useRaspStore((s) => s.getSubmissions);
  const getUserAllData = useRaspStore((s) => s.getUserAllData);
  useEffect(() => {
    const dataFromStore = getSubmissions(userId, "Applicant");
    const allData = getUserAllData(userId);
    console.log("all data from store for student resource", dataFromStore, allData);
  }, [getSubmissions, getUserAllData, userId]);
  const loadMetadata = async () => {
    const metadata = await applicantService.getMetadata();
    const metaFields = metadata[0].fieldValues || [];

    setFields(metaFields);
    // FOREIGNS
    for (let field of metaFields) {
      if (field.foreign) {
        const foreignName = field.foreign;

        if (!fetchedForeign.has(foreignName)) {
          const updated = new Set(fetchedForeign);
          updated.add(foreignName);
          setFetchedForeign(updated);

          const data = await applicantService.getForeignResource(foreignName);

          setForeignKeyData((prev: any) => ({
            ...prev,
            [foreignName]: data,
          }));
        }
      }
    }

    // ENUMS
    for (let field of metaFields) {
      if (field.isEnum) {
        const enumName = field.possible_value;

        if (!fetchedEnum.has(enumName)) {
          const updatedEnum = new Set(fetchedEnum);
          updatedEnum.add(enumName);
          setFetchedEnum(updatedEnum);

          const values = await applicantService.getEnum(enumName);

          setEnums((prev: any) => ({
            ...prev,
            [enumName]: values,
          }));
        }
      }
    }
  };

  const save = async (inputData: any) => {
    // Clone data to avoid mutating component state
    const dataToSave = { ...inputData };
    const params = new FormData();

    const fileKeys = Object.keys(dataToSave).filter((key) => dataToSave[key] instanceof File);
    if (fileKeys.length > 0) {
      fileKeys.forEach(key => {
        params.append(key, dataToSave[key]);
        dataToSave[key] = ""; // Clear file from JSON payload as it's sent in FormData
      });

      params.append("description", "applicant photo");
      params.append("appId", "admission-iiitb");
      params.append("dmsRole", "admin");
      params.append("user_id", userId);
      params.append("tags", "t1,t2,attend");
    }
    const jsonString = JSON.stringify(dataToSave);
    const base64Encoded = btoa(
      encodeURIComponent(jsonString).replace(/%([0-9A-F]{2})/g, (_, p1) =>
        String.fromCharCode(parseInt(p1, 16))
      )
    )
    params.append('resource', base64Encoded);

    const response = await applicantService.create({
      params,
    });

    if (response.errCode !== -1) {
      addSubmission(userId, "Student", dataToSave);
      console.log("data initialized in store in create form model", getUserAllData(userId))
    }
  };

  return {
    fields,
    setFields,
    enums,
    foreignKeyData,
    setForeignKeyData,
    setEnums,
    loadMetadata,
    save,
  };
};
